import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const nameToInitials = (name: string) => {
  if (!name) {
    return "";
  }

  const words = name.trim().split(" ");

  if (words.length === 1) {
    return words[0].slice(0, 2).toUpperCase();
  }

  return (words[0][0] + (words[1]?.[0] || "")).toUpperCase();
};

export const getSubdomain = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");
  if (parts.length > 2) {
    return parts.slice(0, -2).join(".");
  }
  return null;
};

const getDomain = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");
  if (parts.length > 2) {
    return parts.slice(-2).join(".");
  }
  return hostname;
};

const setCookie = (name: string, value: string, ttl: number) => {
  const expires = new Date(Date.now() + ttl).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/; domain=.${getDomain()}; Secure; SameSite=None`;
};

const getCookie = (name: string) => {
  const cookies = document.cookie.split("; ");
  for (const cookie of cookies) {
    const [key, value] = cookie.split("=");
    if (key === name) {
      return value;
    }
  }
  return null;
};

export const setAuthCookie = () => {
  setCookie("SHARED_AUTH", localStorage.getItem("token") || "", 2 * 60 * 1000);
};

export const getAuthCookie = () => {
  return getCookie("SHARED_AUTH");
};

export const clearAuthCookie = () => {
  setCookie("SHARED_AUTH", "", 0);
};

export const parseQuiz = (quiz: string) => {
  // Parse the HTML string
  const parser = new DOMParser();
  const doc = parser.parseFromString(quiz, "text/html");

  // Extract all <p> elements
  const paragraphs = Array.from(doc.querySelectorAll("p"));

  // Extract the question
  const rawQuestion = paragraphs[0].innerText.trim();
  const question = rawQuestion.replace(/^\d+\.\s*/, "");

  // Extract options and find the correct answer
  const options = [];
  let answer = null;

  for (let i = 1; i < paragraphs.length; i++) {
    const text = paragraphs[i].innerText.trim();
    if (!text || text === "<br>") continue;

    if (text.startsWith("+")) {
      const option = text.slice(1).trim();
      options.push(option);
      answer = option;
    } else if (text.startsWith("-")) {
      options.push(text.slice(1).trim());
    }
  }

  return { question, answer, options };
};
